/* Extracted from sections/cro-store-locations.liquid on 2026-08-15.
   Was inline in every document that renders this file; now fetched once and
   cached. Deferred, so it runs after the DOM is parsed rather than at its old
   position — safer for the DOM queries inside, not riskier.
   No Liquid in here, which is why it could move at all. */

/* Defer store-location videos until the section scrolls into view, so the
     (heavy) files stay off the initial page load. Poster images show meanwhile.
     Muted playback is started programmatically (allowed by autoplay policies).
     Respects prefers-reduced-motion. Runs once per page. */
  (function () {
    if (window.__cslVideoObserverInit) return;
    window.__cslVideoObserverInit = true;

    const sections = document.querySelectorAll('.csl');
    if (!sections.length) return;

    const playVideos = (root) => {
      for (const video of root.querySelectorAll('.cro-store-video')) {
        video.preload = 'auto';
        const played = video.play();
        if (played && played.catch) played.catch(() => {});
      }
    };

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return; /* leave posters in place; honour reduced-motion */
    }

    if (!('IntersectionObserver' in window)) {
      for (const section of sections) playVideos(section);
      return;
    }

    /* Play on entry, pause on exit. This used to unobserve after the first
       play, so a video the shopper had scrolled well past kept decoding
       frames for the rest of the session — the cost the lazy-load was meant
       to avoid, just deferred. Threshold 0.5 so it starts when the section is
       genuinely on screen rather than one pixel in. */
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          playVideos(entry.target);
        } else {
          for (const video of entry.target.querySelectorAll('.cro-store-video')) {
            if (!video.paused) video.pause();
          }
        }
      }
    }, { rootMargin: '300px 0px', threshold: 0.5 });

    for (const section of sections) observer.observe(section);
  })();
